export default "<p>\r\n  view-report works!\r\n</p>\r\n"